<template lang="pug">
.purchase-history
  GenericCard.productList(size='85' :ignoreMaxWidth='true')
    .sticky-top.bg-white
      .d-flex.px-4.py-4
        CustomerCompactDetailHeader(:data='customer')

        PanelTitleRight.ml-auto(
          title='ประวัติการซื้อ'
          :subtitle='tableData ? `${totalRows} รายการ`:`...`'
          v-model='filterDate'
        )
      .d-flex.align-items-end.px-4.py-2
        CustomCategoriesFilter(
          title='เลือกดูรายการ'
          :items='statusList'
          v-model='filterStatus'
        )
        CustomSearchBox.ml-auto(
          v-model='filterSearch'
          type='text' placeholder='ค้นหาด้วยเลขที่รายการ'
          :isLoading='isLoading'
        )

      hr.mb-0

    LoadedContentWrapper.flex-fill(
      :isLoading='isLoading'
      :data='tableData'
      @reload='loadData'
    )
      .py-2.px-3.h-scrollable
        CustomTable(
          :columns='tableColumns'
          :data='filteredTableData'
          :showIndexes='true'
          :showNotificationDots='true'
          @itemClicked='showModal'
        )
      .sticky-bottom.bg-white
        hr.m-0
        .px-4.py-3
          CustomPagination(
            v-model='currentPage'
            :total='totalPage'
          )

  modal(
    name='sell-record'
    width='90%' height='95%'
    transition='modal-transition'
  )
    SellRecordDetail(
      :customer='customer'
      :sellRecord='selectedItem'
      @closeButtonClicked='hideModal'
    )

</template>

<script>
/* eslint-disable arrow-body-style */
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';
import SellRecordDetail from '@/components/history/dialogs/SellRecord/SellRecordDetail.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
  },
  watch: {
    // reload data
    filterDate: {
      deep: true,
      handler() { this.currentPage = 1; this.loadData(); },
    },
    filterSearch() { this.currentPage = 1; this.loadData(); },
    filterStatus() { this.currentPage = 1; this.loadData(); },
    currentPage() { this.loadData(); },

    customer() { this.currentPage = 1; this.loadData(); },
  },
  computed: {
    filteredTableData() {
      // const KEYWORD = this.filterSearch.trim().toUpperCase();
      // return this.tableData.filter((item) => {
      //   return (
      //     // (this.filterDate === '' || this.$dateUtils.isInRange(item.date, this.filterDate))
      //     // (!this.filterStatus || item.status.toString() === this.filterStatus)
      //     (!KEYWORD
      //       || item.entryNo.toString().includes(KEYWORD)
      //       || (item.user && item.user.name && item.user.name.toUpperCase().includes(KEYWORD))
      //     )
      //   );
      // });
      return this.tableData;
    },
  },
  data() {
    return {
      isLoading: false,

      // statusList: this.$api.customer.ORDER_STATUS,
      statusList: {
        pending: 'รออนุมัติ',
        submitted: 'อนุมัติ',
        cancelled: 'ไม่อนุมัติ',
        // unix: 'UNIX',
      },
      filterStatus: '',

      filterDate: '',
      filterSearch: '',
      tableData: [],
      tableColumns: {
        entryNo: {
          title: 'เลขที่รายการ',
          align: 'left',
          type: 'EntryNo',
        },
        date: {
          title: 'วันที่ทำรายการ',
          align: 'left',
          type: Date,
        },
        time: {
          title: 'เวลา',
          align: 'left',
          type: this.$api.customer.COL_TYPE.Time,
        },
        total: {
          title: 'ยอดรวม',
          align: 'right',
          type: Number,
          computed(row) {
            if (row.products) {
              return row.products.reduce((total, cur) => {
                return Number(total) + Number(cur.price);
              }, 0);
            }
            return 0;
          },
        },
        sellerName: {
          title: 'ผู้ขาย',
          align: 'right',
          computed(row) {
            if (row.user) {
              return row.user.name;
            }
            return '';
          },
        },
        status: {
          title: 'สถานะ',
          align: 'center',
          type: this.$api.customer.COL_TYPE.OrderStatus,
        },
        shipmentStatus: {
          title: 'สถานะจัดส่ง',
          align: 'center',
          type: this.$api.customer.COL_TYPE.ShipmentStatus,
        },
      },

      currentPage: 1,
      totalPage: 0,
      totalRows: 0,
      pageFirstRowIndex: 1,

      selectedItem: {},
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // reset data
      this.tableData = null;

      try {
        // const res = await this.$api.cs.customerHistory.purchase(this.customer.id);
        const res = await this.$api.customer.history.sell(
          this.customer.id,
          this.currentPage,
          this.filterDate.from,
          this.filterDate.to,
          this.filterStatus,
          this.filterSearch,
        );
        if (res.status === 200) {
          this.tableData = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;
        }
      } catch (e) {
        this.tableData = null;
        this.pageFirstRowIndex = 1;
      }

      this.isLoading = false;
    },
    showModal(e) {
      this.selectedItem = e.data;
      this.$modal.show('sell-record');
    },
    hideModal() {
      // console.log('close');
      this.$modal.hide('sell-record');
      this.loadData();
    },
  },
  mounted() {
    // const id = this.customer ? this.customer.id : '';
    this.loadData();
  },
  components: {
    CustomerCompactDetailHeader,
    SellRecordDetail,
  },
};
</script>

<style lang="scss">
// .purchase-history {}
</style>
